/* eslint-disable no-console */
import pino from 'pino';

/**
 * ログライブラリ pino.js の設定を行います。
 */
const pinoLogger = pino({
  level: import.meta.env.VITE_DEBUG_LOG_LEVEL,
  timestamp: pino.stdTimeFunctions.isoTime,
  browser: {
    write: {
      fatal: console.error,
      error: console.error,
      warn: console.warn,
      info: console.info,
      debug: console.info,
      trace: console.info,
    },
  },
});

export const log = (level: pino.Level, logObj: object) => {
  switch (level) {
    case 'fatal':
      pinoLogger.fatal(logObj);
      break;
    case 'error':
      pinoLogger.error(logObj);
      break;
    case 'warn':
      pinoLogger.warn(logObj);
      break;
    case 'info':
      pinoLogger.info(logObj);
      break;
    case 'debug':
      pinoLogger.debug(logObj);
      break;
    case 'trace':
      pinoLogger.trace(logObj);
      break;
    default:
      break;
  }
};
